/* eslint-disable react/no-multi-comp */
import React from 'react';
import { matchPath } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, Typography } from '@material-ui/core';
import history from '../../history';
import useRouter from '../../utils/useRouter';
import { NavigationListItem } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3)
  }
}));

const NavigationList = props => {
  const { pages, ...rest } = props;
  return (
    <List>
      {pages.map((page, items) => {
        return reduceChildRoutes({ items, page, ...rest })
      })}
    </List>
  );
};

NavigationList.propTypes = {
  depth: PropTypes.number,
  pages: PropTypes.array
};

const reduceChildRoutes = props => {
  const { router, items, page, depth } = props;
  
  if (page.children) {
    var open = false;
    var locationPath = history.location.pathname;
    var pageUrl = '/admin' + page.href;
    
    if(locationPath == '/admin/event/add' || locationPath == '/admin/game/add' || locationPath == '/admin/game/quarter-add' || locationPath == '/admin/report/add') {
      locationPath = '/admin/create-new';

    } else if(locationPath == '/admin/team/add' || locationPath == '/admin/client/add' || locationPath == '/admin/suite/add' || locationPath == '/admin/stadium/add' || locationPath == '/admin/player/add', locationPath == '/admin/icon/add', locationPath == '/admin/emailtemplate/add') {
      locationPath = '/admin/add-new';
    } else if (  locationPath == '/admin/team' || locationPath == '/admin/stadium' ||  locationPath == '/admin/suite' || locationPath.search('admin/team/edit/') >= 0 || locationPath.search('admin/stadium/edit/') >= 0 || locationPath.search('admin/suite/edit/') >= 0) {
      locationPath = '/admin/dashboard/teams';
    } else if(locationPath == '/admin/event' || locationPath == '/admin/game'  || locationPath.search('admin/event/edit/') >= 0 || locationPath.search('admin/game/edit/') >= 0 || locationPath == '/admin/client' || locationPath == '/admin/client/add' || locationPath.search('admin/client/edit/') >= 0 || locationPath.search('admin/client/view/') >= 0 || locationPath == '/admin/team' || locationPath == '/admin/team/add' || locationPath == '/admin/team' && locationPath == '/admin/stadium' ||  locationPath == '/admin/suite' || locationPath.search('admin/team/edit/') >= 0 || (locationPath.search('/guest')) || locationPath == '/admin/emailtemplate') {
      locationPath = '/admin/dashboard';
    }
    
    open = matchPath(locationPath, {
      path: pageUrl,
      exact: false
    });
    
    var nv = (
      <NavigationListItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        label={page.label}
        open={Boolean(open)}
        title={page.title}
      >
        <NavigationList
          depth={depth + 1}
          pages={page.children}
          router={router}
        />
      </NavigationListItem>
    );
  } else {
    var nv = (
      <NavigationListItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        label={page.label}
        title={page.title}
        hasParent={page.hasParent}
      />
    );
  }

  return nv;
};

const Navigation = props => {
  const { title, pages, className, component: Component, ...rest } = props;
  const classes = useStyles();
  const router = useRouter();

  return (
    <Component
     
      className={clsx(classes.root, className)}
    >
      <NavigationList
        depth={0}
        pages={pages}
        router={router}
      />
    </Component>
  );
};

Navigation.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  title: PropTypes.string
};

Navigation.defaultProps = {
  component: 'nav'
};

export default Navigation;
